import { Controller } from "stimulus";

export default class extends Controller {
  oninput(e) {
    e.target.validity.valid || (e.target.value = "");
  }
}
